"use client";
import { motion } from "framer-motion";
import Image from "next/image";

const HeroContent = () => {
  return (
    <motion.div
      className="font-sans relative z-10 text-center md:max-w-4xl max-w-3xl flex flex-col items-center justify-center gap-y-4"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        <Image
          src="/escapa/transp/escapa_3.png"
          alt="Logo Escapa Transparente"
          width={64}
          height={64}
        />
      </motion.div>
      <motion.h1
        className="font-bold text-[28px] md:text-[48px] text-white leading-tight"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
      >
        A primeira Startup no Brasil a criar vídeos e avatares animados de
        <br />
        <span className="text-[#5BE5FF]">
          Inteligência Artificial para o turismo.
        </span>
      </motion.h1>
      <motion.p
        className="md:text-3xl text-2xl font-bold bg-gradient-to-r from-[hsl(var(--secondary))] to-[hsl(var(--accent))] bg-clip-text text-transparent"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.6 }}
      >
        Criatividade & Tecnologia
      </motion.p>
      <motion.span
        className="text-gray-300 text-base font-extralight md:text-xl leading-relaxed tracking-wide"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.6 }}
      >
        Unimos luxo, turismo e tecnologia para criar experiências que
        transformam marcas, destinos e pessoas.
      </motion.span>

      <motion.div
        className="h-12 my-8"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
      >
        <Image
          alt="Arrow"
          src="arrow.svg"
          height={24}
          width={24}
          className="animate-arrow text-white"
        />
      </motion.div>
    </motion.div>
  );
};

export default HeroContent;
